import { Text } from "prism-react";

import { DevtoolMessage } from "./DevtoolMessage";

type Props = {
  processType: "TASK" | "UNASSIGNED_PORT";
  canRestartProcess?: boolean;
  killedBy?: string | null;
  onAction: () => void;
};

export const PROCESS_LABEL: Record<Props["processType"], string> = {
  TASK: "Task",
  UNASSIGNED_PORT: "Dev server",
};

export const ProcessKilledMessage: React.FC<Props> = ({
  canRestartProcess = false,
  onAction,
  killedBy,
  processType,
}) => (
  <DevtoolMessage
    actions={[
      {
        actionText: canRestartProcess ? "Restart" : "Close",
        onAction,
      },
    ]}
    variant="info"
  >
    <Text>
      {PROCESS_LABEL[processType]} was stopped
      {killedBy ? (
        <>
          {" "}
          by <strong>{killedBy}</strong>.
        </>
      ) : (
        <>.</>
      )}{" "}
      {canRestartProcess
        ? "Do you want to restart it?"
        : "Do you want to close it?"}
    </Text>
  </DevtoolMessage>
);
